import React, { useState } from "react";
import { AnalyticsPage, Button, Section } from "@redipos/ui";
import { devToolsApi } from "../api.js";

/**
 * Módulo aislado a propósito — nunca se importa desde otro módulo ni se
 * mezcla con el dashboard principal. Ver
 * docs/analisis/consola-admin-rediseno.md §4.6 y §7 fase 2.
 */
export default function DevToolsPage() {
  const [resetting, setResetting] = useState(false);
  const [msg, setMsg] = useState<string | null>(null);

  const resetDemo = async () => {
    if (!confirm("¿Restablecer solo el tenant demo? Los demás clientes no se modifican.")) return;
    setResetting(true);
    setMsg(null);
    try {
      const r = await devToolsApi.resetDemo();
      setMsg(`Listo. Cuenta demo: ${r.userEmail}.`);
    } catch (e) {
      setMsg(e instanceof Error ? e.message : "Error");
    } finally {
      setResetting(false);
    }
  };

  return (
    <AnalyticsPage title="Herramientas de datos" subtitle="Acciones de mantenimiento. Uso interno, no de negocio.">
      <Section title="Cuenta demo" subtitle="Regenera datos del tenant demo sin afectar otros clientes.">
        <div className="rounded-input border border-warning/30 bg-warning-soft p-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <p className="text-xs text-fg-muted">
            Tenant: <code className="text-fg font-mono text-[11px] bg-surface-elevated px-1 rounded">demo</code>
          </p>
          <Button type="button" variant="secondary" onClick={resetDemo} loading={resetting} loadingLabel="Restableciendo…">
            Restablecer demo
          </Button>
        </div>
        {msg && <p className="text-sm text-success mt-3">{msg}</p>}
      </Section>
    </AnalyticsPage>
  );
}
